<template>
  <a-form-item
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :validate-status="finalStatus"
    :help="finalHelp"
    :hasFeedback="hasFeedback"
  >
    <template slot="label">
      <span v-if="required" class="dol-form-item__required">*</span> {{label}}
    </template>
    <slot />
  </a-form-item>
</template>

<script>
  export default {
    name: "dol-form-item",
    props: {
      label: {type: String},
      labelCol: {
        type: Object, default: () => {
          return {span: 4}
        }
      },
      wrapperCol: {
        type: Object, default: () => {
          return {span: 20}
        }
      },
      validateStatus: {type: String, default: null},
      help: {type: String, default: null},
      hasFeedback: {type: Boolean, default: false},
      required: {type: Boolean, default: false},
      validateType: {type: Array, default: null},
    },
    data(){
      return {
        innerStatus: null,
        innerHelp: null,
      }
    },
    computed:{
      finalStatus(){
        return this.validateStatus || this.innerStatus;
      },
      finalHelp(){
        return this.help || this.innerHelp;
      }
    },
    methods:{
      clearValidate(){
        this.innerHelp = null;
        this.innerStatus = null;
      },
      validate(value){
        let msg;

        if(this.required){
          msg = this.validateRequired(value);
        }

        if(!msg && this.validateType){
          msg = this.validateCustomerType(value);
        }

        if(msg){
          this.innerStatus = 'error';
          this.innerHelp = msg;
        }else{
          this.innerHelp = null;
          this.innerStatus = 'success';
        }
        return !msg;
      },
      validateRequired(value){
        let msg;

        switch(typeof value) {
          case "number":
            if(isNaN(value)){
              msg = this.label + ' 必须为数字';
            }
            break;
          case "object":
            if(value instanceof Array){
              if(value.length === 0){
                msg = this.label + ' 不可为空';
              }
            }else if(value === null){
              msg = this.label + ' 不可为空';
            }
            break;
          case "undefined":
            msg = this.label + ' 不可为空';
            break;
          default:
            if(!value){
              msg = this.label + ' 不可为空';
            }
        }

        return msg;
      },
      validateCustomerType(value){
        let msg;
        if(value){
          this.validateType.forEach(type => {
            switch(type){
              case 'phone':
                if(!/^1\d{10}$/.test(value)){
                  msg = '请输入正确的手机号码';
                }
                break;
              case 'email':
                if(!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(value)){
                  msg = '请输入正确的邮箱';
                }
                break;
              case 'cardID':
                if(!/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)){
                  msg = '请输入正确的身份证号';
                }
                break;
            }
          });
        }
        return msg;
      }
    },
  }
</script>

<style lang="scss" scoped>
.dol-form-item__required{
  color: red;
}
</style>
